<template>
  <div class="edit">
    <div class="edit-content">
      <div class="base-info">
        <p class="edit-title">基本信息</p>
        <div class="edit-middle">
          <input-unit titleKey="机构名称" :initalTitleValue="hospitalTitle" iconKey="机构Logo" :initialIconURL="hospitalLogo"
            @onInputInput="onCompanyInputInput" @onUploadSucceed="onCompanyLogoUploadSucceed"></input-unit>
        </div>
        <div class="edit-row" v-if="isSeniorAdministrator">
          <div class="edit-row-key">机构全称：</div>
          <div class="edit-row-value">
            <el-input v-model="fullName" placeholder="请输入"></el-input>
          </div>
        </div>
        <div class="edit-row" v-if="isSeniorAdministrator">
          <div class="edit-row-key">机构所在地区：</div>
          <div class="edit-row-value">
            <area-picker v-model="address"></area-picker>
          </div>
        </div>
        <div class="edit-row" v-if="isSeniorAdministrator">
          <div class="edit-row-key">机构等级：</div>
          <div class="edit-row-value">
            <el-select v-model="levelId" placeholder="请选择" filterable :popper-append-to-body="false">
              <el-option v-for="item in levelList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="edit-row" v-if="isSeniorAdministrator">
          <div class="edit-row-key">科室：</div>
          <div class="edit-row-value">
            <el-select v-model="departmentId" placeholder="请选择" filterable :popper-append-to-body="false">
              <el-option v-for="item in departmentList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="edit-row" v-if="isSeniorAdministrator">
          <div class="edit-row-key">账号性质：</div>
          <div class="edit-row-value">
            <el-select v-model="natureId" placeholder="请选择" filterable :popper-append-to-body="false">
              <el-option v-for="item in natureList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <!-- <div class="patient-id">
        <p class="edit-title">病案号配置</p>
        <div class="edit-middle">
          <pid-switch-unit :isPatientIdRequired="isPatientIdRequired" :isPatientIdDisplay="isPatientIdDisplay"
            @onRequiredSwitchChange="onPatientIdRequiredChange"
            @onDisplaySwitchChange="onPatientIdDisplayChange"></pid-switch-unit>
        </div>
      </div> -->
    </div>

    <div class="edit-buttons">
      <div class="edit-buttons-container">
        <button class="edit-buttons-container-cancel" @click="onCancelClick">
          取消
        </button>
        <button class="edit-buttons-container-save" @click="onSaveClick">
          保存
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import InputUnit from "@c/setting/organization-configuration/edit/input-unit.vue";
import PickUnit from "@c/setting/organization-configuration/edit/pick-unit.vue";
import PidSwitchUnit from "@c/setting/organization-configuration/edit/pid-switch-unit.vue";
import AreaPicker from "@c/common/area-picker.vue";
import { AreaTool } from "@/assets/js/area-tool";

export default {
  components: {
    InputUnit,
    PickUnit,
    PidSwitchUnit,
    AreaPicker,
  },

  props: {
    model: Object,
  },

  created() {
    this.getLevelList();
    this.getDepartmentList();
    this.getNatureList();
    this.hospitalTitle = this.initialHospitalTitle;
    this.hospitalLogo = this.initialHospitalLogo;
    this.reportTitle = this.initialReportTitle;
    this.reportSubtitle = this.initialReportSubtitle;
    this.reportLogo = this.initialReportLogo;
    this.currentPickedStandardIndex = this.initialPickedStandardIndex;
    this.currentPickedSuggestionIndex = this.initialPickedSuggestionIndex;
    this.isPatientIdDisplay = this.initialIsPatientIdDisplay;
    this.fullName = this.model.fullName;
    this.levelId = this.model.levelId;
    this.departmentId = this.model.departmentId;
    this.natureId = this.model.natureId;
    this.province = this.model.province;
    this.city = this.model.city;
    this.district = this.model.district;
    this.address = AreaTool.convertStrToId(this.province, this.city, this.district);
  },

  data() {
    return {
      iconURL: require("@imgs/logo-placeholder.png"),
      currentPickedStandardIndex: 0,
      currentPickedSuggestionIndex: 0,
      hospitalTitle: "",
      hospitalLogo: "",
      reportTitle: "",
      reportSubtitle: "",
      reportLogo: "",
      isPatientIdRequired: false,
      isPatientIdDisplay: false,
      levelList: [],
      departmentList: [],
      natureList: [],
      fullName: "",
      levelId: "",
      departmentId: "",
      natureId: "",
      province: "",
      city: "",
      district: "",
      address: [],
    };
  },

  computed: {
    initialHospitalTitle() {
      return this.model.hospitalName;
    },

    initialHospitalLogo() {
      if (this.model.hospitalLogo == undefined) {
        return require("@imgs/logo-placeholder.png");
      } else {
        return this.model.hospitalLogo;
      }
    },

    initialReportTitle() {
      return this.model.reportTitle;
    },
    initialReportSubtitle() {
      return this.model.reportSubtitle;
    },

    initialReportLogo() {
      if (this.model.reportLogo == undefined) {
        return require("@imgs/logo-placeholder.png");
      } else {
        return this.model.reportLogo;
      }
    },

    initialPickedStandardIndex() {
      return getObjectValues(CHILD_STANDDARD_TYPE_CODE).indexOf(
        this.model.reportStandard
      );
    },

    initialPickedSuggestionIndex() {
      return getObjectValues(REPORT_SUGGESTION_TYPE).indexOf(
        this.model.reportEvaluate
      );
    },

    initialIsPatientIdDisplay() {
      return this.model.pollShowCaseNumber === "1" ? true : false;
    },

    standDartIndex() {
      return getObjectValues(CHILD_STANDDARD_TYPE_CODE)[
        this.currentPickedStandardIndex
      ];
    },

    suggestionIndex() {
      return getObjectValues(REPORT_SUGGESTION_TYPE)[
        this.currentPickedSuggestionIndex
      ];
    },

    isSeniorAdministrator() {
      return this.$store.getters.isSeniorAdministrator;
    }
  },

  methods: {
    onCompanyInputInput(value) {
      this.hospitalTitle = value;
    },
    onReportInputInput(value) {
      this.reportTitle = value;
    },
    onReportSubInputInput(value) {
      this.reportSubtitle = value;
    },
    onStandardListItemClick(selectedIndex) {
      this.currentPickedStandardIndex = selectedIndex;
    },
    onSuggestionListItemClick(selectedIndex) {
      this.currentPickedSuggestionIndex = selectedIndex;
    },
    onCancelClick() {
      this.$emit("onCancelClick");
    },
    onSaveClick() {
      if (!this.hospitalTitle) {
        this.$toast.showRed("机构名称不能为空");
        return;
      }
      const [province, city, district] = AreaTool.convertIdToStr(this.address);
      console.log(province, city, district);

      this.province = province;
      this.city = city;
      this.district = district;
      const settingInfoModel = {
        hospitalTitle: this.hospitalTitle,
        hospitalLogo: this.hospitalLogo,
        pollShowCaseNumber: this.isPatientIdDisplay ? "1" : "0",
        fullName: this.fullName,
        levelId: this.levelId,
        departmentId: this.departmentId,
        natureId: this.natureId,
        province: this.province,
        city: this.city,
        district: this.district,
      };
      this.$emit("onSaveClick", settingInfoModel);
    },
    onCompanyLogoUploadSucceed(iconURL) {
      this.hospitalLogo = iconURL;
    },
    onReportLogoUploadSucceed(iconURL) {
      this.reportLogo = iconURL;
    },
    onPatientIdRequiredChange(val) {
      this.isPatientIdRequired = val;
    },
    onPatientIdDisplayChange(val) {
      this.isPatientIdDisplay = val;
    },
    async getLevelList() {
      const res = await this.$api.getSleepHospitalLevelList({});
      this.levelList = res;
    },
    async getDepartmentList() {
      const res = await this.$api.getSleepHospitalDepartmentList({});
      this.departmentList = res;
    },
    async getNatureList() {
      const res = await this.$api.getSleepHospitalNatureList({});
      this.natureList = res;
    },
  },
};
</script>

<style lang="scss" scoped>
.edit {
  background-color: white;
  width: 100%;
  height: 100%;
  position: relative;

  .edit-content {
    display: flex;
    justify-content: space-between;
  }

  .base-info {}

  .patient-id {
    width: 400px;
  }

  &-title {
    color: black;
    font-size: rem(16);
    font-weight: bold;
    height: rem(22);
    margin-top: rem(16);
  }

  &-middle {
    margin-top: rem(18);
    display: flex;

    &-right {
      position: absolute;
      left: rem(618);
    }
  }

  &-row {
    display: flex;
    align-items: center;
    margin-top: rem(16);

    &-key {
      width: rem(110);
      font-size: rem(14);
    }

    &-value {
      flex: 1;
      font-size: rem(14);
    }
  }

  &-buttons {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: rem(63);

    &-container {
      display: flex;

      &-cancel {
        color: #325fac;
        font-size: rem(16);
        border: rem(1) solid #325fac;
        border-radius: rem(4);
        width: rem(100);
        height: rem(40);
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &-save {
        color: white;
        background-color: #325fac;
        font-size: rem(16);
        border: rem(1) solid #325fac;
        border-radius: rem(4);
        width: rem(100);
        height: rem(40);
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: rem(50);
      }
    }
  }
}
</style>
